const editTermsConditionsConstantsEn = {
  termsConditionsPageTitle: 'Terms and Conditions',
  termsConditionsBreadcrumb: 'TERMS AND CONDITIONS',
};

export default editTermsConditionsConstantsEn;
